import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

const LoginLocation = () => {


  const [isChecked, setIsChecked] = useState(true);

  const [selectedRows, setSelectedRows] = useState([]);
    



  const handleCheckboxChange = (index, item) => {
  
  
    console.log('Selected Rows:', item);
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
    } else {
      setSelectedRows([...selectedRows, index]);

    }
   
  }


  const userData = useSelector((state) => state.user.user);
  console.log('userData:', userData);

  const navigate = useNavigate();

  const handleHomeClick=()=>{
    navigate('/Billingdasboard')


  }


  const locIdentifiers = userData?.LocIdentifiers || [];


  useEffect(() => {
    // Check if LocIdentifiers has more than one value
    if (locIdentifiers.length == 0) {
      navigate('/Billingdasboard');
    }
  }, [locIdentifiers, navigate]);

  
  // Remove "A$" prefix
  const displayIdentifiers = locIdentifiers.map(loc =>  loc.split('$')[1]);


  useEffect(() => {
    // Initialize selectedRows with all indices
    const allIndices = displayIdentifiers.map((_, index) => index);
    setSelectedRows(allIndices);
}, []);

  
  
  return (
   
    <div className='loc-container'>
    
      <div className='loc-subcontainer'>

        <label className='locheader'>selected Location</label>

<br/>
       <div className='mt-2'>
          {displayIdentifiers.map((identifier, index) => (
            <div key={index}>
              <input type='checkbox'  
               
               checked={selectedRows.includes(index)}
               onChange={() => handleCheckboxChange(index, identifier)}/>

              <label className="labelSelected">{identifier}</label>
            </div>
            
          ))}

          
        </div>

       <br/>

       <input type="button" value="Continue" className="btn btn-primary" onClick={handleHomeClick}></input>
      
      </div>
      
    </div>
     
    
  )
}

export default LoginLocation